module.exports = __webpack_public_path__ + "static/dg3-d14ec17551b9f01a8086db0c724115c3.jpg";